export const authApiUrl = {
  sms: '/v1/customer/send-code',
  login: '/v1/customer/login',
  refresh: '/v1/customer/refresh',
  logout: '/v1/customer/logout',
}

export const lkmAuthApiUrl = {
  sms: '/v1/fitter/send-code',
  login: '/v1/fitter/login',
  refresh: '/v1/fitter/refresh',
  logout: '/v1/fitter/logout',
}
